<template>
  <div v-if="isLoaded">
    <div
      class="content-body"
      v-bind:class="{ fullscreen_expand: isFullscreen }"
    >
      <div class="row match-height">
        <div class="col-xl-12 col-lg-12">
          <div class="card" style="">
            <div class="card-header">
              <h4 class="card-title">Consulta Ciot</h4>
              <a class="heading-elements-toggle"
                ><i class="fa fa-ellipsis-v font-medium-3"></i
              ></a>
              <div class="heading-elements">
                <ul class="list-inline mb-0">
                  <!-- <li>
                    <a
                      @click="onCreate()"
                      v-b-tooltip
                      title="Cadastrar"
                      v-if="getPermissionFw('veiculo.store')"
                      ><i class="fa fa-plus"></i
                    ></a>
                  </li> -->
                  <li>
                    <a
                      @click="onFilterReset()"
                      v-b-tooltip
                      title="Atualizar listagem"
                      ><i class="ft-rotate-cw"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreenFw()"
                      v-b-tooltip
                      title="Expande a tela"
                      v-if="!isFullscreen"
                      ><i class="ft-maximize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreenFw()"
                      v-b-tooltip
                      title="Minimiza a tela"
                      v-if="isFullscreen"
                      ><i class="ft-minimize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onFilterShowHideFw()"
                      v-b-tooltip.hover.left="'Filtros'"
                      ><i class="fa fa-filter"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onActivateDesactivate(1, null, false)"
                      v-b-tooltip
                      title="Ativar Registros"
                      v-if="getPermissionFw('veiculo.status')"
                      ><i class="fa fa-thumbs-o-up"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onActivateDesactivate(2, null, false)"
                      v-b-tooltip
                      title="Inutilizar Registros"
                      v-if="getPermissionFw('veiculo.status')"
                      ><i class="fa fa-thumbs-o-down"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="card-content">
              <div class="table-responsive">
                <div v-if="vuetableFilterRow">
                  <vuetable-filterbar :tabela="'veiculo'"> </vuetable-filterbar>
                </div>
                <div class="loadingDataPosition">
                  <div class="loadingData" v-if="loadingData">
                    <div class="loadingDataSpinner">
                      <spinner
                        v-if="loadingData"
                        text-fg-color="#ffffff"
                        message="Carregando..."
                      ></spinner>
                    </div>
                  </div>
                  <vuetable
                    ref="vuetable"
                    api-url="/api/consultaciot"
                    :fields="fields"
                    :css="css"
                    :append-params="moreParams"
                    track-by="ciot_id"
                    pagination-path=""
                    detail-row-component="ciot-detalhes"
                    @vuetable:cell-clicked="onDetail"
                    @vuetable:load-error="onError"
                    @vuetable:pagination-data="onPaginationData"
                    @vuetable:loaded="onLoaded"
                  >
                    <template slot="transportador" slot-scope="props">
                      <span v-if="props.rowData.carga_ciot.length > 0">{{
                        props.rowData.carga_ciot[0].carga.pessoa.pessoa_juridica
                          .razao_social
                      }}</span>
                    </template>
                    <template slot="num_ciot" slot-scope="props">
                      <span>{{ props.rowData.ciot }}</span>
                    </template>
                    <template slot="vlr_total" slot-scope="props">
                      <span>{{
                        formatNumber(props.rowData.valor_total_ciot)
                      }}</span>
                    </template>
                    <template slot="num_carga" slot-scope="props">
                      <span v-if="props.rowData.carga_ciot.length > 0">{{
                        props.rowData.carga_ciot.carga.num_carga
                      }}</span>
                    </template>
                    <template slot="num_fat" slot-scope="props">
                      <span
                        v-if="
                          props.rowData.carga_ciot.length > 0 &&
                          props.rowData.carga_ciot[0].carga.carga_doc[0]
                            .doc_fiscal.doc_transp_docfis != null &&
                          props.rowData.carga_ciot[0].carga.carga_doc[0]
                            .doc_fiscal.doc_transp_docfis.doc_transp
                            .pre_fatura_despesa_doc[0].pre_fatura_despesa !=
                            null &&
                          props.rowData.carga_ciot[0].carga.carga_doc[0]
                            .doc_fiscal.doc_transp_docfis.doc_transp
                            .pre_fatura_despesa_doc[0].pre_fatura_despesa
                            .fatura_despesa != null
                        "
                        >{{
                          props.rowData.carga_ciot[0].carga.carga_doc[0]
                            .doc_fiscal.doc_transp_docfis.doc_transp
                            .pre_fatura_despesa_doc[0].pre_fatura_despesa
                            .fatura_despesa.num_fiscal
                        }}</span
                      >
                    </template>
                    <template slot="num_pre_fat" slot-scope="props">
                      <span
                        v-if="
                          props.rowData.carga_ciot.length > 0 &&
                          props.rowData.carga_ciot[0].carga.carga_doc[0]
                            .doc_fiscal.doc_transp_docfis != null
                        "
                        >{{
                          props.rowData.carga_ciot[0].carga.carga_doc[0]
                            .doc_fiscal.doc_transp_docfis.doc_transp
                            .pre_fatura_despesa_doc[0].pre_fatura_despesa
                            .num_fiscal
                        }}</span
                      >
                    </template>
                    <template slot="status" slot-scope="props">
                      <span
                        class="badge badge-secondary"
                        v-if="props.rowData.status_envio_encerramento == 1"
                        >Aberto</span
                      >
                      <span
                        class="badge badge-warning"
                        v-if="props.rowData.status_envio_encerramento == 2"
                        >Em Encerramento</span
                      >
                      <span
                        class="badge badge-success"
                        v-if="props.rowData.status_envio_encerramento == 3"
                        >Encerrado</span
                      >
                    </template>
                    <template slot="actions" slot-scope="props">
                      <div class="custom-actions">
                        <a
                          @click="onDetail(props.rowData, null, null)"
                          v-b-tooltip
                          title="Ver detalhes"
                          ><i class="fa fa-plus"></i
                        ></a>
                        <a
                          @click="onEncerraCiot(props.rowData.ciot_id)"
                          v-if="props.rowData.status_envio_encerramento == 1"
                          v-b-tooltip
                          title="Encerrar CIOT"
                          ><i class="fa fa-check-circle-o"></i
                        ></a>
                      </div>
                    </template>
                    <template slot="dt_encerramento" slot-scope="props">
                      <span v-if="props.rowData.status_envio_encerramento == 3">
                        {{ formatDate(props.rowData.dt_alt) }}
                      </span>
                    </template>
                    <template slot="dt_abertura" slot-scope="props">
                      <span>
                        {{ formatDate(props.rowData.dt_inc) }}
                      </span>
                    </template>
                  </vuetable>
                </div>
                <div>
                  <div class="col-md-12">
                    <div class="pull-left pagination-detail">
                      <vuetable-pagination-info
                        ref="paginationInfo"
                        :css="css.pagination"
                        info-class="pull-left"
                      ></vuetable-pagination-info>
                    </div>
                    <div class="pull-right m-a-0">
                      <vuetable-pagination
                        ref="pagination"
                        :css="css.pagination"
                        @vuetable-pagination:change-page="onChangePage"
                      ></vuetable-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vuetable from "../components/Vuetable";
import VuetablePagination from "../components/VuetablePagination";
import VuetablePaginationInfo from "../components/VuetablePaginationInfo";
import ConsultaCiotFilterBar from "./ConsultaCiotFilterBar";
import ConsultaCiotDetalhes from "./ConsultaCiotDetalhes";
import accounting from "accounting";
import moment from "moment";

Vue.component("ciot-detalhes", ConsultaCiotDetalhes);

export default {
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    ConsultaCiotDetalhes,
    "vuetable-filterbar": ConsultaCiotFilterBar,
  },
  data() {
    return {
      dataExport: [],
      statusCiotOptions: [],
      optionsUnidade: [],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      form: new Form({
        ciot_id: "",
      }),
      helpForm: new Form({recordCollection: [], status: '',statusRecord: []}),
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      isLoadingExp: false,
      fields: [
        {
          name: "__checkbox",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
        {
          name: "__slot:transportador",
          title: "Transportador",
          sortField: "transportador",
        },
        {
          name: "__slot:num_ciot",
          title: "N° Ciot",
          sortField: "num_ciot",
        },
        {
          name: "__slot:vlr_total",
          title: "Valor Total",
          sortField: "vlr_total",
        },
        {
          name: "__slot:num_pre_fat",
          title: "N° Pré-Fat",
          sortField: "num_pre_fat",
        },
        {
          name: "__slot:num_fat",
          title: "N° Fatura",
          sortField: "num_fat",
        },
        // {
        //   name: "__slot:num_fat",
        //   title: "N° Fatura",
        //   sortField: "num_fat",
        // },
        {
          name: "__slot:dt_abertura",
          title: "Dt Abertura",
        },
        {
          name: "__slot:dt_encerramento",
          title: "Dt Encerramento",
        },
        {
          name: "__slot:status",
          title: "Status",
          sortField: "status",
        },
        {
          name: "__slot:actions", // <----
          title: "Ações",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
      ],
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  mounted() {
    this.$events.$on("filter-set", (eventData) => this.onFilterSet(eventData));
    this.$events.$on("filter-reset", (e) => this.onFilterReset());
    this.getLivGeral();
  },
  methods: {
    onDetail(data, field, event) {
      if (data) {
        this.$refs.vuetable.toggleDetailRow(data.ciot_id);
      }
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    formatNumber(value) {
      return accounting.formatNumber(value, 2, ".", ",");
    },
    onFilterSet(data_filter) {
      this.loadingData = true;
      this.moreParams = {
        num_ciot: data_filter.num_ciot,
        num_pre_fat: data_filter.num_pre_fat,
        num_fat: data_filter.num_fat,
        num_carga: data_filter.num_carga,
        num_fiscal: data_filter.num_fiscal,
        transportadora: data_filter.transportadora.pessoa_id,
        unidade: data_filter.unidade.value,
        tp_ciot: data_filter.tp_ciot.value,
        status_ciot: data_filter.status_ciot.value,
      };
      Vue.nextTick(() => {
        this.$refs.vuetable.refresh();
      });
    },
    onFilterReset() {
      this.loadingData = true;
      this.moreParams = {};
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    onLoaded: function () {
      this.dataExport = this.$refs.vuetable.tableData;
      this.loadingData = false;
      this.$store.commit("setVuetableFilterButton", false);
    },
    onCreate() {
      this.$refs.veiculoform.onCreate();
    },
    onEdit(data, index) {
      this.id = data.veiculo_id;
      this.$refs.veiculoform.onEdit(data, index, this.id);
    },
    onEncerraCiot(data) {
      this.loading = true;
      this.isDisabled = true;
      this.form.ciot_id = data;
      this.form
        .post("/api/consultaciot/encerraciot")
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    getLivGeral() {
      this.helpForm
        .get("/api/consultaciot/jsonlist")
        .then((response) => {
          new ReturnApi(response, this, true, false, false);
          response.unidade.forEach((obj) => {
            this.optionsUnidade.push({
              label: obj.cd + " - " + obj.descr,
              value: obj.unidade_id,
            });
          });

        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    formatDate(value, fmt = "DD/MM/YYYY") {
      return value == null ? "" : moment(value, "YYYY/MM/DD").format(fmt);
    },
    onActivateDesactivate(action, data, tipo) {
      // Tipo = true = Checkbox
      this.helpForm.status = action;
      if (tipo) {
        this.helpForm.recordCollection = [];
        this.helpForm.recordCollection.push(data.veiculo_id);
      } else {
        this.helpForm.recordCollection = [];
        this.$refs.vuetable.selectedTo.forEach((obj) => {
          this.helpForm.recordCollection.push(obj);
        });
      }
      this.$refs.veiculoform.onActivateDesactivate(this.helpForm);
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
    isFullscreen: {
      get() {
        return this.$store.getters.is_full_screen;
      },
    },
  },
};
</script>